module.exports = __webpack_public_path__ + "img/wrench_inactive.a6666ebb.svg";